var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
export var largeCss = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 16px;\n    line-height: 18px;\n    letter-spacing: 0.3px;\n    padding: ", " ", ";\n  "], ["\n    font-size: 16px;\n    line-height: 18px;\n    letter-spacing: 0.3px;\n    padding: ", " ", ";\n  "])), theme.spacing.two, theme.spacing.four);
});
export var smallCss = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    line-height: 14px;  \n    font-size: 12px;\n    letter-spacing: 0.2px;\n    padding: ", " ", ";\n  "], ["\n    line-height: 14px;  \n    font-size: 12px;\n    letter-spacing: 0.2px;\n    padding: ", " ", ";\n  "])), theme.spacing.one, theme.spacing.three);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
